import type { SDK } from '@wix/dashboard';

export * from './containerExtensions';
export * from './widget';

export type ReactSDK = Pick<
  SDK,
  | 'showToast'
  | 'navigate'
  | 'navigateBack'
  | 'openModal'
  | 'closeModal'
  | 'getAccessToken'
  | 'getPageUrl'
  | 'openMediaManager'
  | 'addSitePlugin'
  | 'onBeforeUnload'
  | 'setPageTitle'
  | 'requestFeedback'
  | 'onLayerStateChange'
>;
